<template>
  <div class="dashboard-overview">
    <div class="overview-header">
      <h2 class="overview-title">{{ title }}</h2>
      <p class="overview-description">{{ description }}</p>
    </div>
    
    <div v-if="loading" class="loading-state">
      <p class="loading-text">Loading dashboards...</p>
    </div>
    
    <div v-else-if="dashboards.length === 0" class="empty-state">
      <p class="empty-text">No dashboards found</p>
    </div>
    
    <div v-else class="dashboards-grid">
      <DashboardCard
        v-for="dashboard in dashboards"
        :key="dashboard.id || dashboard.ID"
        :dashboard="dashboard"
        :can-delete="dashboard.isOwner"
        :can-edit="dashboard.isOwner"
        :can-star="dashboard.canStar"
        :can-share="dashboard.isOwner"
        :is-public="dashboard.isPublic"
        @click="handleCardClick(dashboard)"
        @star="handleStar(dashboard)"
        @edit="handleEdit(dashboard)"
        @delete="handleDelete(dashboard)"
        @share-change="(isPublic) => handleShareChange(dashboard, isPublic)"
      />
    </div>

  </div>
</template>

<script>
import DashboardCard from "./DashboardCard.vue";
import PublicDashboardItem from "./PublicDashboardItem.vue";

export default {
  name: "DashboardOverview",
  components: {
    DashboardCard,
    PublicDashboardItem,
  },
  props: {
    dashboards: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Dashboards",
    },
    description: {
      type: String,
      default: "Here you can view and manage your existing dashboards",
    },
  },
  data() {
    return {
      publicDashboards: [
        {
          id: 101,
          title: "CCE - Oil Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 102,
          title: "Gas Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 103,
          title: "Sample Inventory Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 104,
          title: "Composition Inventory Dashboard 1",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 105,
          title: "Composition Inventory Dashboard 2",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 106,
          title: "Composition Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 107,
          title: "CCE - Oil Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 108,
          title: "Gas Dashboard",
          charts: 4,
          totalCharts: 6,
        },
        {
          id: 109,
          title: "Sample Inventory Dashboard",
          charts: 4,
          totalCharts: 6,
        },
      ],
    };
  },
  methods: {
    handleCardClick(dashboard) {
      this.$emit("dashboard-click", dashboard);
    },
    handleStar(dashboard) {
      this.$emit("star-dashboard", dashboard);
    },
    handleEdit(dashboard) {
      this.$emit("edit-dashboard", dashboard);
    },
    handleDelete(dashboard) {
      this.$emit("delete-dashboard", dashboard);
    },
    handleShareChange(dashboard, isPublic) {
      this.$emit("share-dashboard", dashboard, isPublic);
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/dashboardOverview.css';
</style>

